import { render, staticRenderFns } from "./UploadFieldsMatcher.vue?vue&type=template&id=a6a16920"
import script from "./UploadFieldsMatcher.vue?vue&type=script&lang=js"
export * from "./UploadFieldsMatcher.vue?vue&type=script&lang=js"
import style0 from "./UploadFieldsMatcher.vue?vue&type=style&index=0&id=a6a16920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports